<template>
	<div class="page-wrap">
		<ActionsBar pageTitle="products" :addNew="() => {this.openModal()}"/>
		
		<v-card pa-4 v-if="!loader">
			<div class="data-wrap mt-4">
				<v-expansion-panels class="orders">
					<v-expansion-panel v-for="(item, key) in list" :key="key">
						<v-expansion-panel-header disable-icon-rotate>
							<div class="item-header">
								<div class="item-title">{{ item.title }}</div>
								<div class="item-subtitle">{{ item.slug }}</div>
							</div>
							<template v-slot:actions>
								<v-icon @click="openItemEdit(item)" color="primary">mdi-pencil</v-icon>
								<v-icon class="ml-4">$expand</v-icon>
							</template>
						</v-expansion-panel-header>

						<v-expansion-panel-content>
							<p v-if="item.description">{{ item.description }}
							<div class="storage-units">
								<v-card class="unit" v-for="(unit, key) in item.storageUnits" :key="key">
									<v-img :src="unit.preview" height="200px"></v-img>

									<v-card-title>
										<span>{{unit.title}}</span>
										<v-spacer></v-spacer>
										<v-icon @click="openUnitEdit(unit, item.uid)" color="primary">mdi-pencil</v-icon>
									</v-card-title>

									<v-card-subtitle><span v-if="unit.price">Price: {{unit.price}}</span> <span v-if="unit.quantity">Quantity: {{unit.quantity}}</span></v-card-subtitle>
									
									<div class="unit-details">
										<p><span>SKU Number: </span> {{ unit.sku_number }}</p>
										<div>
											<p v-if="unit.characteristics && unit.characteristics.volume" class="unit-title"><span>Volume: </span> {{ unit.characteristics.volume }}</p>
										</div>
									</div>
								</v-card>
							</div>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
				
				<div class="load-more">
					<v-btn @click="loadMore()"><v-icon>mdi-reload</v-icon> Load more</v-btn>
				</div>
			</div>
		</v-card>

		<div v-else class="loader">
			<v-progress-circular indeterminate color="primary"></v-progress-circular>
		</div>

		<ItemForm v-if="modal1" :item="selectedItem" :modal="modal1" formTitle="Update Item" :action="action" :close="() => {closeModal()}"/>
		<ItemForm v-if="modal2" :unit="selectedItem" :uid="selectedUID" :modal="modal2" formTitle="Update Storage Unit" :action="action" :close="() => {closeModal()}"/>
		<DeleteDialog :modal="deleteModal" :item="selectedItem" :action="action" :close="() => {closeDelete()}"/>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	import ActionsBar from '../components/ActionsBar/ActionsBar.vue';
	import ItemForm from '../components/FormModal/ItemForm.vue';
	import DeleteDialog from '../components/FormModal/DeleteDialog.vue';

	export default {
		name: 'Items',
		components: { ActionsBar, ItemForm, DeleteDialog },
		data: () => {
			return {
				loader: false,
				deleteModal: false,
				modal1: false,
				modal2: false,
				action: '',
				selectedUID: '',
				selectedItem: {
					characteristics: {

					}
				},
				headers: [
					{ text: 'Title', value: 'title' },
					{ text: 'Description', value: 'description'},
					{ text: '', value: 'data-table-expand' },
				],
				expanded: [],
				singleExpand: true
			}
		},

		watch: {
			list(val){
				if(val){
					this.loader = false;
				}
			}
		},
		
		computed: {
			...mapState('Items', ['list'])
		},
		
		mounted(){
			this.loader = true;

			this.$store.dispatch('Items/list');
		},

		methods: {
			openItemEdit(item){
				this.modal1 = true;
				this.selectedItem = Object.assign({}, item);
				this.action = 'Items/updateItem';
			},

			openUnitEdit(unit, uid){
				this.modal2 = true;
				this.selectedItem = Object.assign({}, unit);
				this.selectedUID = uid;
				this.action = 'Items/updateUnit';
			},

			loadMore(){
				this.$store.dispatch('Items/list', 'load');
			},

			openModal(){
				this.modal = true;
				this.action = 'Items/new';
			},

			editItem(item){
				this.modal = true;
				this.selectedItem = Object.assign({}, item);
				this.action = 'Items/update';
			},

			closeModal(){
				this.modal = false;
				this.modal1 = false;
				this.modal2 = false;
				this.selectedItem = {};
				this.action = {};
			},

			deleteItem(item){
				this.deleteModal = true;
				this.selectedItem = Object.assign({}, item);
				this.action = 'Items/remove';
			},

			closeDelete(){
				this.deleteModal = false;
				this.selectedItem = {};
				this.action = '';
			},

			openDetails(){

			}
		}
	}
</script>

<style>

</style>
